module.exports = __webpack_public_path__ + "img/doorLogo8.385cf883.png";